<template>
  <span>
    <!-- <span v-for="item in instance.list" :key="item.key">
      <a-divider v-if="item.divider" type="vertical" />
      <a @click="actionCb(item.cb, scope.scope)">{{item.name}}</a>
    </span> -->
    <span>
        <a @click="actionCb('detail', scope.scope)">详情</a>
    </span>
    <span v-if="status == 2">
        <a-divider type="vertical" />
        <a @click="actionCb('passed', scope.scope)">通过</a>
        <a-divider type="vertical" />
        <a  @click="actionCb('rejected', scope.scope)">驳回</a>
        
    </span>
    <span v-else>
        <a-divider type="vertical" />
        <a  @click="actionCb('edit', scope.scope)">编辑</a>
        <a-divider type="vertical" />
        <a  @click="actionCb('singleDelete', scope.scope)">删除</a>
    </span>
  </span>
</template>

<script>
export default {
  props: {
    instance: Object,
    scope: Object // text, index, scope
  },
  data() {
    return {
    }
  },
  computed: {
    status () {
      const { status, useStatus } = this.scope.scope
      return useStatus || status
    }
  },
  methods: {
    actionCb(cb, row) {
      this.$emit('actionClick', { cb, row })
    }
  }
}
</script>